import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { DropdownMenu } from '@abyss/web/ui/DropdownMenu';
import { Link } from '@abyss/web/ui/Link';
import { SearchInput } from '@abyss/web/ui/SearchInput';

export const ContainerForPlanSelection = styled('div', {
  margin: '24px 0px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

export const ContainerForMultiplePlans = styled('div', {
  paddingTop: '24px',
  paddingBottom: '24px',
  margin: '0px 8px',
  '@screen <= $sm': {
    margin: '0px',
  },
});

export const StyledContainerforPage = styled('div', {});

export const PlanNameLink = styled(Link, {
  textAlign: 'start',
  padding: 0,
  width: 'fit-content',
  '&.abyss-link-root': {
    lineHeight: '18px',
  },
  display: 'inline-block !important',
  '.abyss-link-icon-wrapper': {
    verticalAlign: 'text-top',
  },
});

export const StyledFundedHealthButton = styled(Button, {
  '&.abyss-button-root': {
    marginTop: '0px',
    width: '209px',
    letterSpacing: '0px',
    border: '0px',
    outline: '1px solid #ccc',
    borderRadius: '100px',
    padding: '8px 16px',
    cursor: 'default',
    fontWeight: '$semibold !important',
    lineHeight: '20px !important',
    minHeight: '40px',
    height: 'auto',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    '&:active, &:hover': {
      color: '$white !important',
      border: 'none',
      backgroundColor: '$primary1',
    },
  },
});

export const StyledDropdownMenu = styled(DropdownMenu, {
  '&.abyss-dropdown-menu-trigger': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #929496',
    borderRadius: '500px',
    backgroundColor: '#FFFFFF',
    color: '#323333',
    height: '22px',
    gap: '8px',
    padding: '8px 16px',
  },
  '&.abyss-insert-element-root': {
    gap: '5px',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
  },
});

export const StyledCategoryContainer = styled('div', {});
export const StyledListOfCategoryContainer = styled('div', {
  marginBottom: '16px',
  border: 'none',
  borderRadius: '100px',
  padding: '10px 16px',
  color: '#4B4D4F',
  background: '#F2F2F2',
  width: 'fit-content',
  justifyContent: 'center',
  fontWeight: '700',
  fontStyle: 'Bold',
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '0%',
  textAlign: 'center',
});

export const StyledText = {
  lineHeight: '18px',
  fontWeight: '500',
  fontSize: '14px',
};

export const ContainerPlanNamesFlex = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  '@screen < $md': {
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  },
  gridTemplateRows: 'none',
  gap: '16px 24px',
  paddingLeft: '16px',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export const SearchInputContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledTextForNoResults = {
  '&.abyss-text-root': {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    lineHeight: '20px !important',
    color: '#323333 !important',
  },
};

export const planLabel = {
  paddingLeft: '2px',
  fontSize: '$sm',
  color: '$gray8',
  lineHeight: '18px',
  fontWeight: '700',
};

export const StyledPlanSearch = styled(SearchInput, {
  border: 'none !important',
  '.abyss-search-input-input': {
    boxShadow: 'none',
    border: 'none',
    fontSize: '18px !important',
    color: '#4B4D4F',
    fontWeight: '400',
    padding: '0px 0px 0px 2px !important',
    minHeight: '24px !important',
    '&:focus': {
      boxShadow: 'none',
      border: 'none',
    },
  },
  '&.abyss-search-input-root': {
    border: '1px solid',
    borderRadius: '4px',
  },
  '.abyss-search-input-input-container': {
    alignItems: 'left',
    border: 'none',
  },
  '.abyss-search-input-section': {
    backgroundColor: '$white',
    color: '$gray6',
    fontWeight: '$medium',
  },
  '.abyss-search-input-icon-container': {
    display: 'none',
  },
  '.abyss-search-input-option-icon': {
    display: 'none',
  },
  '.abyss-search-input-right-element-wrapper': {
    height: '24px !important',
    width: '24px !important',
    display: 'absolute',
  },
  '.abyss-search-input-right-element': {
    position: 'relative',
    top: '-12px',
    height: '24px !important',
    width: '24px !important',
  },
  '.abyss-search-input-left-element': {
    display: 'none',
  },
  '.abyss-search-input-left-element-wrapper': {
    display: 'none',
  },
  '&.abyss-search-input-option-list': {
    border: '1px solid $gray4',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
  },
  '&.abyss-search-input-option-list:has(> .abyss-search-input-no-options)': {
    border: 'none',
    boxShadow: 'none',
    display: 'none',
  },
});

export const PlanInputContainer = styled('div', {
  flexWrap: 'nowrap',
  height: '62px',
  backgroundColor: '#FFFFFF',
  margin: '12px 0px',
  border: '1px solid #CBCCCD',
  borderRadius: '50px',
  padding: '8px 24px',
  alignContent: 'center',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  minWidth: '420px',
  width: '62.5%',
  '@screen < $md': {
    width: '80%',
    minWidth: '320px',
  },
  '@screen < $sm': {
    width: '100%',
    minWidth: '100px',
    paddingRight: '10px',
    paddingLeft: '10px',
    '.abyss-search-input-root': {
      minWidth: '150px',
    },
  },
  '.abyss-search-input-root': {
    height: '24px',
  },
  '.abyss-search-input-input': {
    height: '24px',
    background: 'transparent',
    paddingRight: '5px',
  },
});

export const toastErrorStyle = {
  'abyss-toast-description': {
    lineHeight: '20px !important',
    marginRight: '11px !important',
  },
  'abyss-toast-close-button': {
    marginTop: '8px',
  },
};
